import { Button } from 'foundations-components/transitional/components/Button';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { getIsPublished } from '../utils/status';
import { jsx as _jsx } from "react/jsx-runtime";
export const showViewQuoteButton = quote => {
  return getIsPublished(quote);
};
const ViewQuoteButton = ({
  handleClick
}) => {
  return /*#__PURE__*/_jsx(Button, {
    use: "tertiary-light",
    size: "extra-small",
    onClick: handleClick,
    "data-test-id": "view-quote-btn",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "quotesUiLib.quoteActions.viewQuote.buttonText"
    })
  }, "view-quote-btn");
};
export default ViewQuoteButton;